import { FC } from "react";
import { GoogleMap, KmlLayer, LoadScript } from "@react-google-maps/api";

export interface MapProps {
  apiKey: string
  mapUrl: string
  mapContainerClassName?: string
}

const center = {
  lat: 41.876,
  lng: -87.624,
}

export const Map: FC<MapProps> = ({ apiKey, mapUrl, mapContainerClassName = "" }) => (
  <LoadScript googleMapsApiKey={apiKey} libraries={[]}>
    <GoogleMap
      id="kml-layer-example"
      zoom={4}
      center={center}
      mapContainerClassName={mapContainerClassName}
    >
      <KmlLayer url={mapUrl} onLoad={() => null} onUnmount={() => null} />
    </GoogleMap>
  </LoadScript>
)
